// services/consultar_dni.js
export const consultarDNI = async (dni) => {
    try {
        const API_URL = 'https://usefullsofware.com/visioner7_api_services/v1/dxn/productos/consulta_dni.php';

        // Obtener el token del localStorage
        const token = localStorage.getItem('auth_token');

        // Preparar los headers (si no hay token, igual se envía la petición pero el backend responderá 401)
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        // Solo agregar el header Authorization si existe el token
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: headers,
            mode: 'cors',
            body: JSON.stringify({ dni: dni }),
        });

        const data = await response.json();

        return {
            ...data,
            status_code: response.status,
        };

    } catch (error) {
        console.error('Error en consultarDNI:', error);
        return {
            success: false,
            status_code: 0,
            message: error.message || 'Error de conexión con el servidor de consulta DNI',
            dni: dni,
            nombreCompleto: 'No encontrado',
            encontrado: false,
            data: {
                messages: [{
                    code: 'connection_error',
                    message: error.message || 'Error de conexión con el servidor',
                    type: 'ERROR',
                }],
            },
        };
    }
};

export default consultarDNI;